import { catalogueText } from './partsCatalogue';
import type { PartItem } from './partsRun';

// The FULL Phase 2 repartition prompt, authored HERE on the client — instructions, the
// supplied-parts catalogue and the JSON output format — so the "prompt & context sent to
// Gemini" preview can show every word of it and the client sends that exact string, which
// the server uses verbatim. Same rule as stepAnalyzePrompt: one source of truth, so the
// preview and the payload can never drift.
//
// Keep the JSON shape in TAIL in sync with the server's _parse_step_parts.

const HEAD =
  'These images are every assembly step of one furniture manual, in printed order, each ' +
  'captioned with its step ("ASSEMBLY STEP 3, diagram 1"). Read them all before answering.\n' +
  'For each step, give:\n' +
  '- "parts": the supplied parts it NEWLY adds, and how many.\n' +
  '- "tools": the tools (listed under "Tools:" below) its diagram shows or its text asks for.\n' +
  '- "textEn" / "textFr": one line on what the step achieves.\n' +
  'Counting:\n' +
  '- A diagram redraws earlier parts for context. Count only the new ones.\n' +
  '- Match parts by their callout letter/reference, else by shape. Never add a part the ' +
  'diagram does not call out.\n' +
  '- At a joint, count the fastening points in the zoomed detail.\n' +
  '- The totals across all steps must equal each part\'s "supplied xN". Never exceed it; ' +
  'leave units over only if the manual does (a spare screw).\n' +
  '- A tool is never a part.\n' +
  '- Give every step an entry, in order, even one that adds nothing ("parts": []).\n' +
  'The line (textEn / textFr):\n' +
  '- Which pieces are joined to which, with which tools, and what the assembly becomes. ' +
  'Not the order of the gestures.\n' +
  '- Name each piece and tool with its letter. Every tool in ' +
  '"tools" appears in the line; none other does.\n' +
  '- Write the French natively, not as a translation.\n' +
  'Supplied parts (id -> description):\n';

const TAIL =
  '\nReply with ONLY this JSON, no prose, no code fence, using the ids above and the step ' +
  'numbers from the captions:\n' +
  '{"steps": [{"step": <number>, "textEn": <string>, "textFr": <string>, ' +
  '"tools": [{"id": <id string>}], ' +
  '"parts": [{"id": <id string>, "qty": <integer newly added in this step>}]}]}.';

// Assemble the whole prompt exactly as it is sent: instructions, then the catalogue, then
// the JSON format.
export function buildStepPartsPrompt(items: PartItem[]): string {
  return HEAD + (catalogueText(items) || '(no supplied-parts list provided)') + TAIL;
}
